import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-switchpay-callback-version-two',
  templateUrl: './switchpay-callback.component.html',
  styleUrls: ['./switchpay-callback.component.scss']
})
export class SwitchpayCallbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
